import React, { Component } from 'react';
import Input from '../../shared/input/Input';
import SelectList from '../../shared/select/SelectList';
import PropTypes from 'prop-types';
import './ContractorForm.css';
import uploadSvg from 'images/upload.svg';
import Dropzone from 'react-dropzone';
import DocumentLink from 'components/shared/document/DocumentLink';
import removeSvg from 'images/remove.svg';

class ContractorForm extends Component {
  static propTypes = {
    edit: PropTypes.bool,
    needsConfirmation: PropTypes.bool,
    form: PropTypes.object,
    invalidFields: PropTypes.array,
    serviceAreas: PropTypes.array,
    selectedServiceAreasId: PropTypes.array,
    selectedTradesId: PropTypes.array,
    selectedUnionsId: PropTypes.array,
    w9Document: PropTypes.object,
    trades: PropTypes.array,
    unions: PropTypes.array,
    validationMessage: PropTypes.string,
    withInvitation: PropTypes.bool,
    onFormChange: PropTypes.func.isRequired,
    onServiceAreaSelection: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onTradesSelection: PropTypes.func.isRequired,
    onUnionSelection: PropTypes.func.isRequired,
    onW9DocumentChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    edit: false,
    needsConfirmation: false,
    form: {},
    invalidFields: [],
    selectedServiceAreasId: [],
    selectedTradesId: [],
    selectedUnionsId: [],
    serviceAreas: [],
    trades: [],
    unions: [],
    validationMessage: '',
    withInvitation: true,
  };

  title = () => {
    if (this.props.needsConfirmation) {
      return 'Confirm your Information';
    }

    return this.props.edit ? 'Edit Contractor' : 'Add a Contractor';
  };

  filterState = () => {
    return this.props.form.state !== null ? this.props.form.state : '';
  };

  render() {
    return (
      <div className="contractor-form">
        <div className="full-title">{this.title()}</div>

        <div className="contractor-form-container">
          <div className="left-side">
            <div className="h2">Company Details</div>
            <div>
              <table className="details-table">
                <tbody>
                  {this.props.edit ? (
                    <tr>
                      <td>{this.renderField('Company Name', 'companyName')}</td>
                      <td>
                        {this.renderField(
                          'License Number',
                          'licenseNumber',
                          this.props.needsConfirmation
                        )}
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td>{this.renderField('Company Name', 'companyName')}</td>
                      <td />
                    </tr>
                  )}
                </tbody>
              </table>

              <hr />

              <table className="details-table">
                <tbody>
                  <tr>
                    <td>
                      {this.renderField('Contact First Name', 'firstName')}
                    </td>
                    <td colSpan={2}>
                      {this.renderField('Contact Last Name', 'lastName')}
                    </td>
                  </tr>

                  <tr>
                    <td>{this.renderField('Email', 'email')}</td>
                    <td colSpan={2}>
                      {this.renderField('Phone Number', 'phoneNumber')}
                    </td>
                  </tr>

                  <tr>
                    <td>
                      {this.renderField('Street Address', 'streetAddress')}
                    </td>
                    <td colSpan={2}>
                      {this.renderField('Unit number / Floor', 'unitNumber')}
                    </td>
                  </tr>

                  <tr>
                    <td>{this.renderField('City', 'city')}</td>
                    <td>{this.renderField('State', 'state')}</td>
                    <td>{this.renderField('Zip Code', 'zipCode')}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="h2 radios-container">Specialities (Trades)</div>
            <div tabIndex="0">
              <SelectList
                showAs="table"
                values={this.props.trades.map((element) => {
                  return {
                    id: element.id,
                    value: element.label,
                    selected:
                      this.props.selectedTradesId.find(
                        (selected) => selected === element.id
                      ) !== undefined,
                  };
                })}
                onSelect={this.props.onTradesSelection}
              />
            </div>

            <div className="h2 radios-container">Areas of Service</div>
            <div tabIndex="0">
              <SelectList
                showAs="table"
                values={this.props.serviceAreas
                  .filter((element) => element.state === this.filterState())
                  .map((element) => {
                    return {
                      id: element.id,
                      value: element.name,
                      selected:
                        this.props.selectedServiceAreasId.find(
                          (selected) => selected === element.id
                        ) !== undefined,
                    };
                  })}
                onSelect={this.props.onServiceAreaSelection}
              />
            </div>

            <div className="h2 radios-container">
              Which unions do you belong to?
            </div>
            <div tabIndex="0">
              <SelectList
                showAs="table"
                values={this.props.unions
                  .map((element) => {
                    return {
                      id: element.id,
                      value: element.label,
                      selected:
                        this.props.selectedUnionsId.find(
                          (selected) => selected === element.id
                        ) !== undefined,
                    };
                  })
                  .concat({
                    id: 'all',
                    value: 'All',
                    selected:
                      this.props.selectedUnionsId.length ===
                      this.props.unions.length,
                  })}
                onSelect={this.props.onUnionSelection}
              />
            </div>

            {this.props.validationMessage !== '' && (
              <div className="invalid-message">
                {this.props.validationMessage}
              </div>
            )}

            <div className="buttons">
              <input
                className="btn button button-gray"
                type="button"
                value={this.props.edit ? 'Save' : 'Only Add'}
                onClick={this.props.onSubmit.bind(this, false)}
              />
              {this.props.withInvitation && (
                <input
                  className="btn button button-orange"
                  type="button"
                  value={
                    this.props.edit ? 'Save and Send Invite' : 'Send Invite'
                  }
                  onClick={this.props.onSubmit.bind(this, true)}
                />
              )}
            </div>
          </div>

          <div className="right-side">
            <div className="h2">W9 Document</div>

            {this.props.w9Document.document === '' &&
            this.props.w9Document.url === '' ? (
              <div>
                <div className="body-bold files-title">
                  Please drag and drop any file into this area
                </div>
                <div
                  className={`dropzone-container${
                    this.props.needsConfirmation &&
                    !this.props.invalidFields.find((el) => el === 'w9Document')
                      ? ' highlighted'
                      : ''
                  }${
                    this.props.invalidFields.find((el) => el === 'w9Document')
                      ? ' dropzone-with-error'
                      : ''
                  }`}
                >
                  <Dropzone
                    accept="application/pdf, .doc, .docx, .xls, .xlsx"
                    className="files-dropzone"
                    multiple={false}
                    onDrop={(files) => this.props.onW9DocumentChange(files[0])}
                  >
                    <img src={uploadSvg} alt="remove" />
                  </Dropzone>
                </div>
              </div>
            ) : (
              <div className="file-viewer">
                <DocumentLink
                  file={this.props.w9Document.document}
                  url={
                    this.props.w9Document.document === ''
                      ? this.props.w9Document.url
                      : null
                  }
                  showIcon={false}
                  showLink={true}
                />
                <img
                  src={removeSvg}
                  alt="remove"
                  onClick={() => this.props.onW9DocumentChange('')}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderField(placeholder, attribute, highlighted = false) {
    const valid =
      this.props.invalidFields.find((element) => element === attribute) ===
      undefined;
    return (
      <Input
        placeholder={placeholder}
        valid={valid}
        value={this.props.form[attribute]}
        className={highlighted && valid ? 'highlighted' : ''}
        onChange={this.props.onFormChange.bind(this, attribute)}
      />
    );
  }
}

export default ContractorForm;



// WEBPACK FOOTER //
// ./src/components/admin/contractors/ContractorForm.js